import { REQUEST, SUCCESS, FAILURE } from '../../../store'
import {
  LOAD_COURSE_ACTIVITY_USER_LIST,
  LOAD_STUDY_COURSE_TIME,
  LOAD_STUDY_COURSE_HISTORY,
  LOAD_COURSE_RANKING_ALL,
  LOAD_COURSE_RANKING_NISSOKEN,
  LOAD_COURSE_RANKING_COMPANY,
  UPDATE_BOOKMARK
} from './constants'

export function loadCourseActivityUserList() {
  return {
    type: REQUEST(LOAD_COURSE_ACTIVITY_USER_LIST)
  }
}

export function loadCourseActivityUserListSuccess(data) {
  return {
    type: SUCCESS(LOAD_COURSE_ACTIVITY_USER_LIST),
    data
  }
}

export function loadCourseActivityUserListError(error) {
  return {
    type: FAILURE(LOAD_COURSE_ACTIVITY_USER_LIST),
    error
  }
}

export function loadStudyCourseTime(payload) {
  return {
    type: REQUEST(LOAD_STUDY_COURSE_TIME),
    payload
  }
}

export function loadStudyCourseTimeSuccess(data) {
  return {
    type: SUCCESS(LOAD_STUDY_COURSE_TIME),
    data
  }
}

export function loadStudyCourseTimeError(error) {
  return {
    type: FAILURE(LOAD_STUDY_COURSE_TIME),
    error
  }
}

export function loadStudyCourseHistory(payload) {
  return {
    type: REQUEST(LOAD_STUDY_COURSE_HISTORY),
    payload
  }
}

export function loadStudyCourseHistorySuccess(data) {
  return {
    type: SUCCESS(LOAD_STUDY_COURSE_HISTORY),
    data
  }
}

export function loadStudyCourseHistoryError(error) {
  return {
    type: FAILURE(LOAD_STUDY_COURSE_HISTORY),
    error
  }
}

export function loadCourseRankingAll(payload) {
  return {
    type: REQUEST(LOAD_COURSE_RANKING_ALL),
    payload
  }
}

export function loadCourseRankingAllSuccess(data) {
  return {
    type: SUCCESS(LOAD_COURSE_RANKING_ALL),
    data
  }
}

export function loadCourseRankingAllError(error) {
  return {
    type: FAILURE(LOAD_COURSE_RANKING_ALL),
    error
  }
}

export function loadCourseRankingNissoken(payload) {
  return {
    type: REQUEST(LOAD_COURSE_RANKING_NISSOKEN),
    payload
  }
}

export function loadCourseRankingNissokenSuccess(data) {
  return {
    type: SUCCESS(LOAD_COURSE_RANKING_NISSOKEN),
    data
  }
}

export function loadCourseRankingNissokenError(error) {
  return {
    type: FAILURE(LOAD_COURSE_RANKING_NISSOKEN),
    error
  }
}

export function loadCourseRankingCompany(payload) {
  return {
    type: REQUEST(LOAD_COURSE_RANKING_COMPANY),
    payload
  }
}

export function loadCourseRankingCompanySuccess(data) {
  return {
    type: SUCCESS(LOAD_COURSE_RANKING_COMPANY),
    data
  }
}

export function loadCourseRankingCompanyError(error) {
  return {
    type: FAILURE(LOAD_COURSE_RANKING_COMPANY),
    error
  }
}

export function updateBookmarkRequest(payload) {
  return {
    type: REQUEST(UPDATE_BOOKMARK),
    payload
  }
}

export function updateBookmarkSuccess({ data, item }) {
  return {
    type: SUCCESS(UPDATE_BOOKMARK),
    payload: { data, item }
  }
}

export function updateBookmarkError(error) {
  return {
    type: FAILURE(UPDATE_BOOKMARK),
    error
  }
}
